/**
 * Shared labels and line order for Florist One flower price breakdowns.
 *
 * Florist One taxes product + delivery, so UI lines MUST appear as:
 * Product → Delivery fee → Tax → Scheduled Smiles savings → Total
 * (never Tax above Delivery fee; never understate Tax).
 */

/** User-facing labels for flower quote / order amount lines. */
export const FlowerOrderPriceLineLabels = {
  previousPrice: 'Previous price',
  product: 'Product',
  newProductPrice: 'New product price',
  catalogPrice: 'Catalog Price',
  deliveryFee: 'Delivery fee',
  tax: 'Tax',
  /** Fallback when a promotion credit exists but no public headline was snapshotted. */
  promotionSavingsFallback: 'Promotion savings',
  /** Legacy generic label; prefer {@link buildFlowerPromotionSavingsLabel}. */
  scheduledSmilesSavings: 'Scheduled Smiles savings',
  orderTotal: 'Order total',
  newOrderTotal: 'New order total',
  authorizedTotal: 'Authorized Total',
  /** Settled Orders detail grand total (Bug #1415). */
  totalCharged: 'Total charged',
} as const;
